<template>
  <!-- 申请明细 -->
  <div class="page-container">
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label>
          <el-input v-model="filterForm.purchaseName" clearable placeholder="请输入采购方名称"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input v-model="filterForm.contactName" clearable placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input v-model="filterForm.coalCategoryName" clearable placeholder="请输入煤种"></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.status" clearable placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.createTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="计划创建开始时间"
            end-placeholder="计划创建结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handlerSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button icon="fa fa-share" label="重置" perms="-1" type="primary" @click="handleReset" />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      :data="particularsList"
      v-loading="loading"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="id"
    >
      <el-table-column type="index" width="50" align="center" fixed label="序号"></el-table-column>
      <el-table-column prop="bookingNo" align="center" width="120" label="预约编号"></el-table-column>
      <el-table-column prop="coalMineName" align="center" min-width="120" label="煤矿"></el-table-column>
      <el-table-column prop="purchaseName" align="center" width="150" label="采购方"></el-table-column>
      <el-table-column prop="contactName" align="center" width="100" label="联系人"></el-table-column>
      <el-table-column prop="contactPhone" align="center" width="120" label="联系人电话"></el-table-column>
      <el-table-column prop="coalCategoryName" align="center" width="120" label="煤种"></el-table-column>
      <el-table-column prop="createTime" align="center" width="180" label="计划创建时间"></el-table-column>
      <el-table-column prop="bookingCarCount" align="center" width="120" label="预约车辆数（车）"></el-table-column>
      <el-table-column prop="approvalCarCount" align="center" width="120" label="报名车辆数（车）"></el-table-column>
      <el-table-column prop="remainingCarCount" align="center" width="120" label="入场车辆数（车）"></el-table-column>
      <el-table-column fixed="right" prop="statusDesc" align="center" width="120" label="状态"></el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

let that = null;
export default {
  components: {
    KtButton
  },
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      statusList: [],
      particularsList: [],
      filterForm: {
        coalMineName: "",
        purchaseName: "",
        contactName: "",
        coalCategoryName: "",
        status: "",
        bookingDate: ''
      }
    };
  },
  mounted() {
    this.getStatusList();
    this.getParticularsList();
  },
  methods: {
    // 获取状态列表
    getStatusList() {
      this.$api.apply.mGetStatusList().then(res => {
        if (res.data && res.data.length > 0) {
          this.statusList = res.data;
        } else {
          this.statusList = [];
        }
      });
    },

    // 获取采购方列表
    async getParticularsList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        coalMineNo: this.coalMineNo
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params[
              "searchFieldList[" + index + "].rangeMinValue"
            ] = `${val[0]} 00:00:00`;
            params[
              "searchFieldList[" + index + "].rangeMaxValue"
            ] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.apply.mGetBookingList(params);
      this.totalSize = res.data.totalSize || 0;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        this.particularsList = res.data.dtoList;
      } else {
        this.particularsList = [];
      }
      this.loading = false;
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getParticularsList();
    },

    // 搜索
    handlerSearch() {
      this.pageNo = 1;
      this.getParticularsList();
    },

    // 重置
    handleReset() {
      this.filterForm = {
        coalMineName: "",
        purchaseName: "",
        contactName: "",
        coalCategoryName: "",
        status: "",
        bookingDate: ''
      };
      this.handlerSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

.addressMap {
  width: 100%;
  height: 200px;
  margin-top: 20px;
}
</style>
